import {RouteEntrypoint} from '../features/navigation'

import {
  SECTION_COMPANY_PROFILE,
  SECTION_CORPORTATE_REPRESENTATIVES,
  SECTION_DOCUMENTS,
  SECTION_PAYMENT_INFORMATION,
} from '../constants/sections'

import {WelcomePage} from '../pages/intro'

// company profile
import {
  CreateLegalRepresentativePage,
  ExistingLegalRepresentativePage,
  LegalRepSummaryPage,
  CreateDirectorPage,
  ExistingDirectorPage,
  DirectorSummaryPage,
  CreateBeneficialOwnerPage,
  ExistingBeneficialOwnerPage,
  BeneficialOwnerSummaryPage,
  ExistingSellerBankAccountPage,
  ExistingDirectDebitAccount,
  SellerBankAccountSummaryPage,
  CreateIntermediaryShareHolderPage,
  ExistingIntermediaryShareholderPage,
  IntermediaryShareholderSummaryPage,
  DirectDebitAccountSummary,
  RegistrationNumbersPage,
  OverviewPage,
} from '../pages/company-profile'
import DummyRedirectPage from '../pages/dummy-redirect-page'

// company documents
import {
  CompanyDocumentsPage,
  CompanyFinancialDocumentsPage,
  CompanyGroupFinancialDocumentsPage,
  CompanyOtherDocumentsPage,
} from '../pages/company-documents'

// trade partners
import {
  ExistingSellerTradePartnersPage,
  SellerTradePartnerSummaryPage,
  CreateSellerTradePartnersPage,
} from '../pages/seller-trade-partners'

import {
  ROUTE_COMPANY_PROFILE,
  ROUTE_COMPANY_PROFILE_BANK_DETAILS,
  ROUTE_COMPANY_PROFILE_BANK_DETAILS_BY_ID,
  ROUTE_COMPANY_PROFILE_BANK_DETAILS_CREATE,
  ROUTE_COMPANY_PROFILE_BENEFICIAL_OWNERS,
  ROUTE_COMPANY_PROFILE_BENEFICIAL_OWNERS_BY_ID,
  ROUTE_COMPANY_PROFILE_BENEFICIAL_OWNERS_CREATE,
  ROUTE_COMPANY_PROFILE_DIRECT_DEBIT_ACCOUNT_DETAILS,
  ROUTE_COMPANY_PROFILE_DIRECT_DEBIT_ACCOUNT_DETAILS_BY_ID,
  ROUTE_COMPANY_PROFILE_DIRECT_DEBIT_ACCOUNT_DETAILS_CREATE,
  ROUTE_COMPANY_PROFILE_LEGAL_REPRESENTATIVES,
  ROUTE_COMPANY_PROFILE_LEGAL_REPRESENTATIVES_BY_ID,
  ROUTE_COMPANY_PROFILE_LEGAL_REPRESENTATIVES_CREATE,
  ROUTE_COMPANY_PROFILE_DIRECTORS,
  ROUTE_COMPANY_PROFILE_DIRECTORS_BY_ID,
  ROUTE_COMPANY_PROFILE_DIRECTORS_CREATE,
  ROUTE_COMPANY_PROFILE_INTERMEDIARY_SHAREHOLDERS,
  ROUTE_COMPANY_PROFILE_INTERMEDIARY_SHAREHOLDERS_BY_ID,
  ROUTE_COMPANY_PROFILE_INTERMEDIARY_SHAREHOLDERS_CREATE,
  ROUTE_COMPANY_PROFILE_REGISTRATION_NUMBERS,
  ROUTE_COMPANY_TRADE_PARTNERS,
  ROUTE_COMPANY_TRADE_PARTNERS_BY_ID,
  ROUTE_ONBOARDING,
  ROUTE_WELCOME,
  ROUTE_COMPANY_DOCUMENTS_LIST,
  ROUTE_COMPANY_FINANCIAL_DOCUMENTS,
  ROUTE_COMPANY_TRADE_PARTNERS_CREATE,
  ROUTE_INTRO,
  ROUTE_COMPANY_PROFILE_OVERVIEW,
  ROUTE_CORPORATE_REPRESENTATIVES,
  ROUTE_PAYMENT_INFORMATION,
  ROUTE_DOCUMENTS,
  ROUTE_COMPANY_GROUP_FINANCIAL_DOCUMENTS,
  ROUTE_COMPANY_OTHER_DOCUMENTS,
} from './constants'

// Pre-underwriting
import PreUnderwritingContainer from '../pages/intro/pre-underwriting-form'

export default [
  {
    path: '/',
    component: DummyRedirectPage,
  },
  {
    path: ROUTE_ONBOARDING,
    redirectTo: ROUTE_COMPANY_PROFILE,
  },
  {
    path: ROUTE_WELCOME,
    component: WelcomePage,
    layoutProps: {
      hideFooter: true,
      hasFixedLayout: true,
    },
  },
  {
    path: ROUTE_INTRO,
    component: PreUnderwritingContainer,
    layoutProps: {
      hideFooter: true,
    },
  },
  // seller trade partners
  {
    path: ROUTE_COMPANY_TRADE_PARTNERS,
    component: SellerTradePartnerSummaryPage,
    layoutProps: {
      sectionName: SECTION_COMPANY_PROFILE,
      isSubSection: true,
    },
  },
  {
    path: ROUTE_COMPANY_TRADE_PARTNERS_CREATE,
    component: CreateSellerTradePartnersPage,
    layoutProps: {
      sectionName: SECTION_COMPANY_PROFILE,
      isSubSection: true,
    },
  },
  {
    path: ROUTE_COMPANY_TRADE_PARTNERS_BY_ID,
    component: ExistingSellerTradePartnersPage,
    layoutProps: {
      sectionName: SECTION_COMPANY_PROFILE,
      isSubSection: true,
    },
  },

  {
    path: ROUTE_CORPORATE_REPRESENTATIVES,
    component: RouteEntrypoint,
    componentProps: {sectionName: SECTION_CORPORTATE_REPRESENTATIVES},
  },
  {
    path: ROUTE_PAYMENT_INFORMATION,
    component: RouteEntrypoint,
    componentProps: {sectionName: SECTION_PAYMENT_INFORMATION},
  },
  {
    path: ROUTE_DOCUMENTS,
    component: RouteEntrypoint,
    componentProps: {sectionName: SECTION_DOCUMENTS},
  },

  /**
   * COMPANY PROFILE
   */
  {
    path: ROUTE_COMPANY_PROFILE,
    component: RouteEntrypoint,
    componentProps: {sectionName: SECTION_COMPANY_PROFILE},
    layoutProps: {
      sectionName: SECTION_COMPANY_PROFILE,
    },
  },
  {
    path: ROUTE_COMPANY_PROFILE_OVERVIEW,
    component: OverviewPage,
    layoutProps: {
      sectionName: SECTION_COMPANY_PROFILE,
      isSubSection: true,
    },
  },
  {
    path: ROUTE_COMPANY_PROFILE_REGISTRATION_NUMBERS,
    component: RegistrationNumbersPage,
    layoutProps: {
      sectionName: SECTION_COMPANY_PROFILE,
      isSubSection: true,
    },
  },
  {
    path: ROUTE_COMPANY_PROFILE_LEGAL_REPRESENTATIVES,
    component: LegalRepSummaryPage,
    layoutProps: {
      sectionName: SECTION_COMPANY_PROFILE,
      isSubSection: true,
    },
  },
  {
    path: ROUTE_COMPANY_PROFILE_LEGAL_REPRESENTATIVES_CREATE,
    component: CreateLegalRepresentativePage,
    layoutProps: {
      sectionName: SECTION_COMPANY_PROFILE,
      isSubSection: true,
    },
  },
  {
    path: ROUTE_COMPANY_PROFILE_LEGAL_REPRESENTATIVES_BY_ID,
    component: ExistingLegalRepresentativePage,
    layoutProps: {
      sectionName: SECTION_COMPANY_PROFILE,
      isSubSection: true,
    },
  },
  {
    path: ROUTE_COMPANY_PROFILE_DIRECTORS,
    component: DirectorSummaryPage,
    layoutProps: {
      sectionName: SECTION_COMPANY_PROFILE,
      isSubSection: true,
    },
  },
  {
    path: ROUTE_COMPANY_PROFILE_DIRECTORS_CREATE,
    component: CreateDirectorPage,
    layoutProps: {
      sectionName: SECTION_COMPANY_PROFILE,
      isSubSection: true,
    },
  },
  {
    path: ROUTE_COMPANY_PROFILE_DIRECTORS_BY_ID,
    component: ExistingDirectorPage,
    layoutProps: {
      sectionName: SECTION_COMPANY_PROFILE,
      isSubSection: true,
    },
  },
  {
    path: ROUTE_COMPANY_PROFILE_BENEFICIAL_OWNERS,
    component: BeneficialOwnerSummaryPage,
    layoutProps: {
      sectionName: SECTION_COMPANY_PROFILE,
      isSubSection: true,
    },
  },
  {
    path: ROUTE_COMPANY_PROFILE_BENEFICIAL_OWNERS_CREATE,
    component: CreateBeneficialOwnerPage,
    layoutProps: {
      sectionName: SECTION_COMPANY_PROFILE,
      isSubSection: true,
    },
  },
  {
    path: ROUTE_COMPANY_PROFILE_BENEFICIAL_OWNERS_BY_ID,
    component: ExistingBeneficialOwnerPage,
    layoutProps: {
      sectionName: SECTION_COMPANY_PROFILE,
      isSubSection: true,
    },
  },
  {
    path: ROUTE_COMPANY_PROFILE_INTERMEDIARY_SHAREHOLDERS,
    component: IntermediaryShareholderSummaryPage,
    layoutProps: {
      sectionName: SECTION_COMPANY_PROFILE,
      isSubSection: true,
    },
  },
  {
    path: ROUTE_COMPANY_PROFILE_INTERMEDIARY_SHAREHOLDERS_CREATE,
    component: CreateIntermediaryShareHolderPage,
    layoutProps: {
      sectionName: SECTION_COMPANY_PROFILE,
      isSubSection: true,
    },
  },
  {
    path: ROUTE_COMPANY_PROFILE_INTERMEDIARY_SHAREHOLDERS_BY_ID,
    component: ExistingIntermediaryShareholderPage,
    layoutProps: {
      sectionName: SECTION_COMPANY_PROFILE,
      isSubSection: true,
    },
  },
  {
    path: ROUTE_COMPANY_PROFILE_BANK_DETAILS,
    component: SellerBankAccountSummaryPage,
    layoutProps: {
      sectionName: SECTION_COMPANY_PROFILE,
      isSubSection: true,
    },
  },
  {
    path: ROUTE_COMPANY_PROFILE_BANK_DETAILS_CREATE,
    component: ExistingSellerBankAccountPage,
    layoutProps: {
      sectionName: SECTION_COMPANY_PROFILE,
      isSubSection: true,
    },
  },
  {
    path: ROUTE_COMPANY_PROFILE_BANK_DETAILS_BY_ID,
    component: ExistingSellerBankAccountPage,
    layoutProps: {
      sectionName: SECTION_COMPANY_PROFILE,
      isSubSection: true,
    },
  },
  {
    path: ROUTE_COMPANY_PROFILE_DIRECT_DEBIT_ACCOUNT_DETAILS,
    component: DirectDebitAccountSummary,
    layoutProps: {
      sectionName: SECTION_COMPANY_PROFILE,
      isSubSection: true,
    },
  },
  {
    path: ROUTE_COMPANY_PROFILE_DIRECT_DEBIT_ACCOUNT_DETAILS_CREATE,
    component: ExistingDirectDebitAccount,
    layoutProps: {
      sectionName: SECTION_COMPANY_PROFILE,
      isSubSection: true,
    },
  },
  {
    path: ROUTE_COMPANY_PROFILE_DIRECT_DEBIT_ACCOUNT_DETAILS_BY_ID,
    component: ExistingDirectDebitAccount,
    layoutProps: {
      sectionName: SECTION_COMPANY_PROFILE,
      isSubSection: true,
    },
  },

  // company documents
  {
    path: ROUTE_COMPANY_DOCUMENTS_LIST,
    component: CompanyDocumentsPage,
    layoutProps: {
      sectionName: SECTION_COMPANY_PROFILE,
      isSubSection: true,
    },
  },
  {
    path: ROUTE_COMPANY_FINANCIAL_DOCUMENTS,
    component: CompanyFinancialDocumentsPage,
    layoutProps: {
      sectionName: SECTION_COMPANY_PROFILE,
      isSubSection: true,
    },
  },
  {
    path: ROUTE_COMPANY_GROUP_FINANCIAL_DOCUMENTS,
    component: CompanyGroupFinancialDocumentsPage,
    layoutProps: {
      sectionName: SECTION_COMPANY_PROFILE,
      isSubSection: true,
    },
  },
  {
    path: ROUTE_COMPANY_OTHER_DOCUMENTS,
    component: CompanyOtherDocumentsPage,
    layoutProps: {
      sectionName: SECTION_COMPANY_PROFILE,
      isSubSection: true,
    },
  },
]
